module.exports = __webpack_public_path__ + "static/media/ic-groceries.00f1b210.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-groceries.svg
// module id = 628
// module chunks = 14